import { PlatformType } from "../platform/platform-type";

export default defineNuxtPlugin({
    name: "webos-plugin",
    dependsOn: ['platform'],
    async setup () {
        try {
            const { $platform } = useNuxtApp();
            const { platformType } = await $platform.getInfo();
            
            if (platformType === PlatformType.WebOS && import.meta.env.VITE_APPLICATION_PLATFORM === "LG") {
                await import("@ca.vmedia.tv/webos");
            }
        } catch (error) {
            console.error("Failed to load WebOS plugin:", error);
        }
    }
});
